<script setup>
import { onMounted, ref } from 'vue';
import { useBusinessModelTypologiesStore } from '../stores/businessModelTypologies';
import { useProcurementTypesStore } from '../stores/procurementTypes';
import { useCitiesStore } from '../stores/cities';
import { useCityPopulationRangesStore } from '../stores/cityPopulationRanges';
import { useCountriesStore } from '../stores/countries';
import apiFetch from '@wordpress/api-fetch';
import FilterPanel from './FilterPanel.vue';

defineProps({
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const businessModelTypologiesStore = useBusinessModelTypologiesStore();
const procurementTypesStore = useProcurementTypesStore();
const countriesStore = useCountriesStore();
const citiesStore = useCitiesStore();
const cityPopulationRangesStore = useCityPopulationRangesStore();
const strings = ref(null);

onMounted(async () => {
  try {
    const lang = document.documentElement.lang?.substring(0, 2);
    const translations = await apiFetch({
      path: `/wp-json/ebus/market/translations?lang=${lang}`,
    });

    strings.value = translations;
  } catch (error) {
    console.error('Error: ', error);
  }
});
</script>

<template>
  <h3 class="font-ibm-plex-mono! font-medium! text-lg! leading-tight! text-black!">
    {{ strings?.filter_by }}
  </h3>

  <div v-if="strings" class="flex! flex-col! gap-y-2! lg:gap-y-4!">
    <FilterPanel
      :title="strings?.country"
      :items="countriesStore.countries"
      :active-values="countriesStore.activeCountries"
      :is-loading="isLoading"
      value-field="code"
      @toggle="countriesStore.toggleCountry"
    />

    <FilterPanel
      :title="strings?.city_region"
      :items="citiesStore.cities"
      :active-values="citiesStore.activeCities"
      :is-loading="isLoading"
      value-field="slug"
      @toggle="citiesStore.toggleCity"
    />

    <FilterPanel
      :title="strings?.city_population_range"
      :items="cityPopulationRangesStore.ranges"
      :active-values="cityPopulationRangesStore.activeRanges"
      :is-loading="isLoading"
      value-field="slug"
      @toggle="cityPopulationRangesStore.toggleRange"
    />

    <FilterPanel
      :title="strings?.procurement_type"
      :items="procurementTypesStore.procurementTypes"
      :active-values="procurementTypesStore.activeProcurementTypes"
      :is-loading="isLoading"
      value-field="slug"
      @toggle="procurementTypesStore.toggleProcurementType"
    />

    <FilterPanel
      :title="strings?.business_model_typology"
      :items="businessModelTypologiesStore.businessModelTypologies"
      :active-values="businessModelTypologiesStore.activeBusinessModelTypologies"
      :is-loading="isLoading"
      value-field="slug"
      @toggle="businessModelTypologiesStore.toggleBusinessModelTypology"
    />
  </div>
</template>
